var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserFilled = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C23 14.9494 21.8392 17.6276 19.9497 19.6029C17.954 21.689 15.1455 22.9909 12.0328 23C12.0219 23 12.011 23 12 23C11.989 23 11.9781 23 11.9672 23C8.85447 22.9909 6.04595 21.689 4.05035 19.6029C2.16075 17.6276 1 14.9494 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM18.6673 17.5C17.0822 15.5805 14.6839 14.3571 12 14.3571C9.31609 14.3571 6.91791 15.5805 5.33266 17.5C6.91791 19.4195 9.31609 20.6429 12 20.6429C14.6839 20.6429 17.0822 19.4195 18.6673 17.5ZM12.0002 12.7857C14.1699 12.7857 15.9288 11.0268 15.9288 8.8571C15.9288 6.68741 14.1699 4.92852 12.0002 4.92852C9.8305 4.92852 8.07162 6.68741 8.07162 8.8571C8.07162 11.0268 9.8305 12.7857 12.0002 12.7857Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/UserFilled.318624354edb4cc982fef67bbec71204.svg";